import services from '../../services/services';

export const addProcedure = ({ plan, ...rest }) => dispatch => {
  return;
};

export const deleteProcedure = payload => ({
  type: 'procedure/DELETE',
  payload
});

export const updateProcedure = payload => ({
  type: 'procedure/EDIT',
  payload
});

export const updateDate = payload => ({
  type: 'procedure/UPDATE_DATE',
  payload
});

export const getProceduresTypes = () => dispatch =>
  services
    .vpp('getProceduresTypesWithToken')
    .then(data => {
      dispatch({
        type: 'procedure/ADD_TYPES',
        payload: data
      });
      return Promise.resolve();
    })
    .catch(err => {
      throw new Error(err.message);
    });

/* Here happens a new world */

export const loadPlanProceduresAction_ME = ({ credenId, planId }) => dispatch => {
  dispatch({
    type: 'procedure/LOADING',
    payload: true
  });
  let datInicio = localStorage.getItem('datInicio');
  let datFim = localStorage.getItem('datFim');

  localStorage.removeItem('datInicio');
  localStorage.removeItem('datFim');

  return services
    .procedimento_ME('getPlanProcedures_ME', { credenId, planId, datInicio, datFim })
    .then(res => {
      dispatch({
        type: 'procedure/LOAD_PROCEDURES_ME',
        payload: res
      });
      dispatch({
        type: 'procedure/LOADING',
        payload: false
      });

      return Promise.resolve();
    })
    .catch(err => {
      dispatch({
        type: 'procedure/LOADING',
        payload: false
      });

      return Promise.reject(err);
    });
};

export const deletePlanProcedureAction_ME = params => dispatch =>
  services
    .procedimento_ME('deleteProcedure_ME', params)
    .then(() => Promise.resolve())
    .catch(err => Promise.reject(err.message));

export const addPlanProcedureToWillBeGtoAction_ME = item => (dispatch, getState) => {
  const state = getState();
  const { willBeGto } = state.procedures;

  const isDuplicated = willBeGto.some(e => e.procedureId === item.procedureId);

  // !isDuplicated && willBeGto.push(item.procedureId);
  !isDuplicated && willBeGto.push(item);

  dispatch({
    type: 'procedure/ADDTOWILLBEGTO',
    payload: willBeGto
  });
};

export const removePlanProcedureToWillBeGtoAction_ME = item => (dispatch, getState) => {
  const state = getState();
  const { willBeGto } = state.procedures;

  const stillWillBeGto = willBeGto.filter(f => f.procedureId !== item.procedureId);

  dispatch({
    type: 'procedure/REMOVE_FROM_WILLBEGTO',
    payload: stillWillBeGto
  });
};

export const setToDefaultPlanProcedureToWillBeGtoAction_ME = item => (dispatch, getState) => {
  const state = getState();
  const { procedures } = state.procedures.proceduresME;

  const persistedProcedures = procedures.filter(e => e.procedureId !== item.procedureId);

  const manipulatedItem = {
    ...item,
    executeDate: null,
    images: []
  };

  const updatedProcedures = [...persistedProcedures, manipulatedItem];

  /* FALLBACK_TO_DEFAULT REMOVE DATA AND IMAGES */
  dispatch({
    type: 'procedure/FALLBACK_TO_DEFAULT',
    payload: updatedProcedures
  });
};

export const updatePlanProcedureAction_ME = ({ item, params }) => (dispatch, getState) => {
  const state = getState();
  const { procedures } = state.procedures.proceduresME;

  procedures.forEach(e => {
    if (e.procedureId === item.procedureId) {
      Object.keys(params).forEach(key => (item[key] = params[key]));
    }
  });

  dispatch({
    type: 'procedure/EDIT_PROCEDURES_ME',
    payload: procedures
  });
};

export const addImgToPlanProcedureAction_ME = ({ item, img }) => (dispatch, getState) => {
  const state = getState();
  const { procedures } = state.procedures.proceduresME;

  const updatedProcedures = procedures.map(p => {
    if (p.procedureId === item.procedureId) {
      p.imagesToBeGto = img.img;
    }

    return p;
  });

  dispatch({
    type: 'procedure/ADD_IMAGES',
    payload: updatedProcedures
  });
};

export const removeImgToPlanProcedureAction_ME = ({ item, imageRemove }) => (
  dispatch,
  getState
) => {
  const state = getState();
  const { procedures } = state.procedures.proceduresME;

  const updatedProcedures = procedures.map(m => {
    if (m.procedureId === item.procedureId) {
      m.imagesToBeGto.splice(imageRemove.index, 1);
    }

    return m;
  });

  dispatch({
    type: 'procedure/REMOVE_IMAGES',
    payload: updatedProcedures
  });
};
